import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { UserImageId, UserImage, UserImagesAppState } from 'interfaces/userImage'
import { ImageId } from 'interfaces/media'
import { getItemFromCollection } from 'helpers/normalizeHelpers'

export const userImagesCollectionSelector = (state: State) => state.app.userImages
export const userImagesByIds = (userImages: UserImagesAppState, props: { ids: UserImageId[] }) =>
  props.ids.reduce<UserImage[]>((acc, id) => {
    const image = userImages.byKey[id]
    if (image) {
      acc.push(image)
    }
    return acc
  }, [])

export const userImageSelector = createSelector(
  userImagesCollectionSelector,
  (_state: State, id: UserImageId | null) => id,
  (userImages, id) => {
    if (!userImages) {
      return null
    }
    return getItemFromCollection<UserImage, 'id'>(userImages, id)
  }
)

export const userImageByIdSelector = createSelector(
  userImagesCollectionSelector,
  (_state: State, id: ImageId | null) => id,
  (userImages, id) => {
    const userImageId = userImages.allKeys.find((imageId) => {
      const userImage = userImages.byKey[imageId]
      return !!(userImage.image && userImage.image.id === id)
    })
    return userImageId ? userImages.byKey[userImageId] : null
  }
)
